// extracted by mini-css-extract-plugin
module.exports = {"moreLink":"TelefonAlternativ_moreLink__vXHDw"};